export const skipInactivityUrls = ['/','/login', '/settings'];
export const skipOrderTypeModelUrls = ['/'];